import { render } from "./TrimEditorMain.vue?vue&type=template&id=a29379da&scoped=true"
import script from "./TrimEditorMain.vue?vue&type=script&lang=js"
export * from "./TrimEditorMain.vue?vue&type=script&lang=js"

import "./TrimEditorMain.vue?vue&type=style&index=0&id=a29379da&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a29379da"]])

export default __exports__